import { gql } from '@apollo/client';

export const UPDATE_AI_ANALYSIS = gql`
  mutation UpdateAIAnalysis(
    $record: UpdateByIdRagAnalysisInput!
    $id: MongoID!
  ) {
    ragAnalysisSchemaUpdateById(record: $record, _id: $id) {
      record {
        isFalsePositive
        metadata {
          status
        }
      }
    }
  }
`;
